// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__nIxb6","Footer":"footer_Footer__TFJcx","Logo":"footer_Logo__osqOM"};